import { useBasketStore } from '@/store/basket/basket'

import { DeliveryMethods } from '@/api/modules/basket/types'

export const useBasketMethods = () => {
  const fetchBasket = async () => {
    const { fetchBasket } = useBasketStore()

    await fetchBasket()
  }

  const handleRedirectCity = async () => {
    const { setDeliveryMethod } = useBasketStore()

    const route = useRoute()
    const router = useRouter()

    if (!route.query.addressId) return

    await setDeliveryMethod({
      delivery_method: DeliveryMethods.COURIER,
      address_id: Number(route.query.addressId),
    })

    await router.replace({ query: null })
  }

  return {
    fetchBasket,
    handleRedirectCity,
  }
}
